/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {ILogService} from 'angular';
import {IStateService} from 'angular-ui-router';
import {ApplicationPropertyRS} from '../../admin/service/applicationPropertyRS.rest';
import {IAnlaufstelleVerwaltungParams} from '../../anlaufstelleverwaltung/anlaufstelleverwaltung.route';
import AuthServiceRS from '../../authentication/service/AuthServiceRS.rest';
import TSAnlaufstelle from '../../models/TSAnlaufstelle';
import ErrorService from '../errors/service/ErrorService';
import AnlaufstelleRS from './AnlaufstelleRS.rest';
import BenutzerRS from './BenutzerRS.rest';
import RoleUtilService from './RoleUtilService';
import moment = require('moment');

export default class VereinbarungAkzeptiertService {

    static $inject = ['ErrorService', '$log', 'AuthServiceRS', 'RoleUtilService', 'BenutzerRS', 'AnlaufstelleRS', 'CONSTANTS', '$state',
        'ApplicationPropertyRS'];

    vereinbarungValid: number = 0;

    /* @ngInject */
    constructor(private errorService: ErrorService, private $log: ILogService,
                private authService: AuthServiceRS, private roleUtilService: RoleUtilService,
                private benutzerRS: BenutzerRS, private anlaufstelleRS: AnlaufstelleRS, private CONSTANTS: any,
                private $state: IStateService, private applicationPropertyRS: ApplicationPropertyRS) {
    }

    $onInit() {
        this.applicationPropertyRS.getVereinbarungValidYears().then((response) => {
            this.vereinbarungValid = response;
        });
    }

    public checkVereinbarungAkzeptiert() {
        let isAnlaufstelleVerwalter = this.authService.isOneOfRoles(this.roleUtilService.getAnlaufstelleVerwalterOnlyRole());

        if (isAnlaufstelleVerwalter) {
            let principal = this.authService.getPrincipal();
            if (principal !== undefined) {

                //anlaufstellen lesen fuer die der benutzer der verwalter ist
                this.benutzerRS.getAnlaufstellenForBenutzer(principal.id).then((anlaufstellen: Array<TSAnlaufstelle>) => {
                    let missingVereinbarungAnlaufstellen = this.filterAbgelaufeneAnlaufstellen(anlaufstellen);
                    if (missingVereinbarungAnlaufstellen.length !== 0) {
                        this.$log.warn('Not all Vereinbarungen are akzeptiert, redirecting to page Anlaufstellenverwaltung');

                        let verwaltungParams: IAnlaufstelleVerwaltungParams;
                        verwaltungParams = {missingVereinbarungAnlaufstelle: missingVereinbarungAnlaufstellen};
                        this.$state.go('anlaufstelleverwaltung', verwaltungParams);
                    }
                });

            }
            //checken ob die anlaufs
        }

    }

    private filterAbgelaufeneAnlaufstellen(anlaufstellen: Array<TSAnlaufstelle>): Array<TSAnlaufstelle> {
        let invalidAnlaufstellen: Array<TSAnlaufstelle> = [];
        for (let currAnlaufstelle of anlaufstellen) {
            let akzeptiertDate = currAnlaufstelle.vereinbarungAkzeptiert;
            //wenn noch nicht akzeptiert oder schon abgelaufen
            if (akzeptiertDate === undefined
                || akzeptiertDate.add(this.vereinbarungValid, 'years').isBefore(moment())) {
                invalidAnlaufstellen.push(currAnlaufstelle);
            }

        }
        return invalidAnlaufstellen;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/VereinbarungAkzeptiertService.ts